module.exports = __webpack_public_path__ + "img/falvzhichi.022ccb35.png";